<template>
    <div class="vehiclePage scrollBar-custom">
        <div class="formTitle">
            <span>车辆信息</span>
        </div>
        <Card :header="info.licenseNo || '暂未绑定车辆'">
            <el-form label-width="120px" label-position="left">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="车辆号牌">
                            <span v-if="info.licenseNo" :style="getPlateStyle(info.licenseNo)">{{ formatPlateNumber(info.licenseNo) }}</span>
                            <span v-else>-</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="号牌颜色">
                            <el-tag v-if="info.licenseColor" :type="licenseColorTagType(info.licenseColor)" size="small">{{ licenseColorLabel(info.licenseColor) }}</el-tag>
                            <span v-else>-</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="核载人数">
                            <el-tag v-if="info.vehicleSeat" size="small">{{ info.vehicleSeat }}座</el-tag>
                            <span v-else>-</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="车辆型号">
                            <span>{{ info.vehicleModel || '-' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="车身颜色">
                            <el-tag v-if="info.vehicleColor" type="info" size="small">{{ info.vehicleColor }}</el-tag>
                            <span v-else>-</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="车辆编号">
                            <span>{{ info.vehicleNo || '-' }}</span>
                        </el-form-item>
                    </el-col>
                    <template v-if="mixinUserInfo.platformType === 1 || mixinUserInfo.platformType === 2">
                        <el-col :span="8">
                            <el-form-item label="车辆责任人">
                                <span>{{ info.vehicleResponsible || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车辆所属">
                                <span>{{ info.vehicleCompanyName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </template>
                </el-row>
            </el-form>
        </Card>
    </div>
</template>

<script>
export default {
    props: {
        info: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        licenseColorLabel(val) {
            const item = this.$const.LICENSECOLOR && this.$const.LICENSECOLOR.find(c => c.value === val);
            return item ? item.label : val || '-';
        },
        licenseColorTagType(val) {
            const label = this.licenseColorLabel(val);
            if (label.includes('绿')) return 'success';
            if (label.includes('黄')) return 'warning';
            if (label.includes('黑')) return 'danger';
            return '';
        },
    }
}
</script>